// faq tabs toggal start
function togal_tabs (item) {
  item.addEventListener("click", () => {
     toggal_all_tabs(item.getAttribute('data-faq_content'));
  });        
}
function toggal_all_tabs(tabs_data){
  let tabs_button = document.querySelectorAll("[data-faq_content]");
  tabs_button.forEach(b => {
    if(b.getAttribute('data-faq_content') == tabs_data){
      if(b.classList.contains('is_open')){
         b.classList.remove("is_open");    
        }else{
         b.classList.add("is_open");
        }
    }else{
       b.classList.remove("is_open");
    }
  });             
}
function faq_taggol() {
  let tabs_title = document.querySelectorAll("[data-faq_content]");
  tabs_title.forEach(togal_tabs);
}
faq_taggol();
// faq tabs toggal end

// faq tabs toggal content start
function tab_mai_mappert(item) {
  item.addEventListener("click", () => {
     toggal_all_tabs_content(item.getAttribute('data-hendles'));
  });        
}
function toggal_all_tabs_content(tabs_data){
  let tabs_content_toggel = document.querySelectorAll("[data-hendles]");
  tabs_content_toggel.forEach(b => {
    if(b.getAttribute('data-hendles') == tabs_data){
         b.classList.add("active");
        document.querySelector(b.getAttribute('data-hendles')).style.display = 'block';
    }else{
       b.classList.remove("active");
       document.querySelector(b.getAttribute('data-hendles')).style.display = 'none';
    }
  });                   
}
let tabs_content  = document.querySelectorAll("[data-hendles]");
tabs_content.forEach(tab_mai_mappert);
// faq tabs toggal content end

const swiper = new Swiper('.cust_collection .swiper', {
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  autoplay: {
    delay: 3000,
    disableOnInteraction: true,
  },
  breakpoints: {
      320: {
        slidesPerView: 2,
        spaceBetween:20,
        loop: false,
        centeredSlides: false,
      },
      750: {
        slidesPerView: 3.5,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
      },
  },
});

 var swiperfimgwithpro = new Swiper(".product_with_img_slider", {
  slidesPerView: 1,
  spaceBetween: 0,
  freeMode: false,
  navigation: {
    nextEl: ".swiper-im-with-pro-button-next",
    prevEl: ".swiper-im-with-pro-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 2,
      spaceBetween: 25,
    },
  },
});

$(document).on('mouseenter','.pin_item', function() {
   const data_id_cust_slide = this.getAttribute('data-product-handle');
   const slider_index =  document.querySelector(data_id_cust_slide).getAttribute("data-slide-id");
   swiperfimgwithpro.slideTo(slider_index,200,false);
})

var $slider = $('.cust_slider .swiper-wrapper .swiper-slide.cust_img').attr('card_img');
if ($slider > 1) {
  
  var swiperFeatureImg = new Swiper(".cust_slider", {
    slidesPerView: 1,
    spaceBetween: 0,
    // autoplay: {
    //   delay: 3000,-pr
    //   disableOnInteraction: false,
    // },
    freeMode: false,
    navigation: {
      nextEl: ".product-card-wrapper .swiper-button-next",
      prevEl: ".product-card-wrapper .swiper-button-prev",
    }
  });
} else {
  // Hide navigation buttons if there's only one image
  $(".swiper-button-next, .swiper-button-prev").hide();
}


 $(function() {
  var Accordion = function(el, multiple) {
    this.el = el || {};
    this.multiple = multiple || false;

    // Variables privadas
    var links = this.el.find('.js-acc-single-trigger');
    // Evento
    links.on('click', {el: this.el, multiple: this.multiple}, this.dropdown)
  }
if ($(window).width() < 769){  
  Accordion.prototype.dropdown = function(e) {
    var $el = e.data.el;
      $this = $(this),
      $next = $this.next();

    $next.slideToggle();
    $this.parent().toggleClass('open');

    if (!e.data.multiple) {
      $el.find('.accordion-single-content').not($next).slideUp().parent().removeClass('open');
    };
  } 
}
  var accordion = new Accordion($('#accordion'), false);
});  

$('.faq_tab_btn ul li:first').addClass("active_tab");
  $('.faq_tab_btn ul li a').on('click',function (e) {
    e.preventDefault();
    $('.faq_tab_btn ul li').removeClass("active_tab");
    $(this).parent('li').addClass("active_tab");
    var target = this.hash;
    var $target = $(target);
    $('html, body').stop().animate({
        'scrollTop': $target.offset().top - $(".header-wrapper").offset().top
      }, 900, 'swing', function () {
    });
  });

$('.cust_class').hide();
$(document).on('click', '.facets__heading', function(){
  $('.cust_class').slideToggle();
  $('.active-facets-vertical-filter').toggleClass('cust_slide');
});


// Mobile Menu Search Bar Js
$('#menu-drawer .header__icon--search').click(function(){
   $('.header').addClass('mobile_search_active');
});
$('#menu-drawer .search-modal__close-button,#menu-drawer .reset__button.field__button').click(function(){
   $('.header').removeClass('mobile_search_active');
});

$(document).on('mouseup', function(e) {
  if (!$(e.target).is('#menu-drawer .search-modal .search-modal__content') && !$(e.target).parents().is('#menu-drawer .search-modal .search-modal__content')) {
    $('.header').removeClass('mobile_search_active');
  }
});

const red_more_product = document.querySelector(".product__featured_detail");
if (red_more_product) {
  if (red_more_product.querySelectorAll('.feature_content').length == 3) {
    red_more_product.classList.add('icon_block_3');
    
  }else if (red_more_product.querySelectorAll('.feature_content').length == 2) {
    red_more_product.classList.add('icon_block_2');
    
  }else if (red_more_product.querySelectorAll('.feature_content').length == 4) {
    red_more_product.classList.add('icon_block_4');
    
  }
  else{
    red_more_product.classList.add('icon_block_1');    
  }
}
